import { getBuildingById } from 'src/api/get-building.api';
import { VerifyPolicyInput } from 'src/redux/reducer/v2/verifyPolicy';

type Building = Awaited<ReturnType<typeof getBuildingById>>;
type BuildingAddress = VerifyPolicyInput['address'];

export const getBuildingAddress = (building: Building): BuildingAddress => {
  return {
    street:
      building?.fullAddress?.street?.trim().split(' ').slice(1).join(' ') || '',
    shortNameStreet: building?.fullAddress?.street || '',
    addressNumber: building?.fullAddress?.street?.trim().split(' ')[0] || '',
    postalCode: building?.fullAddress?.postalCode || '',
    municipality: building?.fullAddress?.municipality || '',
    state: building?.fullAddress?.region || '',
  };
};
